import TermsView from './Terms.View';

const Terms = () => <TermsView />;

export default Terms;
